import { Button } from "@/shared/ui/button.tsx";
import { SetStateAction, useAtomValue } from "jotai";
import { Check, X } from "lucide-react";
import { useRegenerateEvent } from "../../api";
import { useRef } from "react";
import RegenerateThemeLoader from "@/shared/loaders/RegenerateThemeLoader";
import posthog from "posthog-js";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";

type Props = {
  event_id: number,
  story_id: number | null,
  setShowPrompt: React.Dispatch<SetStateAction<boolean>>
}

const PromptForm = ({ setShowPrompt, event_id, story_id }: Props) => {

  const promptInputRef = useRef<HTMLTextAreaElement | null>(null)

  const { regenerateEvent, status } = useRegenerateEvent(() => {
    setShowPrompt(false)
  })

  const regenerateHandler = (prompt: string) => {

    const data = story_id === null ?
    {event_id: event_id, prompt: prompt} : { event_id: event_id, story_id: story_id, prompt: prompt }

    posthog.capture('theme regenerated', data)
    regenerateEvent({ event_id: data.event_id, prompt: data.prompt, story_id: data.story_id })
  }

  const appTheme = useAtomValue(themeAtom)

  return (
    <>
      {status !== "pending" &&
        <div className="h-full rounded-xl bg-white p-3 bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-60 shadow-md shadow-purple-300">
          <p className="font-poppins tracking-wide text-gray-500 h-[2rem]">Prompt</p>
          <textarea ref={promptInputRef} rows={5} className="w-full text-sm resize-none bg-transparent focus:border focus:border-gray-200 focus:outline-none rounded-xl p-2 text-gray-700 font-poppins tracking-wider" />
          <div className="flex flex-wrap items-center gap-2">
            {/* space for prompt array */}
          </div>

        </div>
      }
      {status === "pending" && (
        <RegenerateThemeLoader />
      )}
      <div className="flex items-center justify-end gap-2">

        <Button
          onClick={() => setShowPrompt(false)}
          type="button" size="icon" className="rounded-full border-2 border-purple-300" variant="outline">
          <X />
        </Button>
        <Button
          disabled={!appTheme.isClient}
          onClick={() => {
            if (promptInputRef && promptInputRef.current) {
              regenerateHandler(promptInputRef.current.value)
            }
          }}
          type="button" size="icon" className="rounded-full border-2 border-purple-300" variant="outline">
          <Check />
        </Button>
      </div>
    </>
  )
}

export default PromptForm;
